<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
    <ClientNav class="hideOnPrint"/>
    <v-row dense class="hideOnPrint">
      <v-col cols="12" lg="3" xl="2">
        <ClientSide />
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-card class="pa-2" outlined tile height="100%">
          <v-data-table
              :headers="headers"
              :items="monthlySummaries"
              sort-by="StartDate"
              sort-desc
              :loading="isLoading"
              loading-text="Loading Monthly Summaries"
              :search="search"
              height="550"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Monthly Summaries</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    clearable
                    flat
                    solo-inverted
                    hide-details
                    prepend-inner-icon="search"
                    label="search"
                    class="desktop"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn
                    fab
                    small
                    @click="printTable()"
                    class="mr-8 mb-2 white--text"
                    color="#2b6993"
                    elevation="4"
                    >
                    <v-icon>print</v-icon>
                </v-btn>
                  <v-btn v-if="!isAuditorRole" color="#2b3990" dark class="mb-2" @click="showAdd()">
                      <v-icon left>add</v-icon>Add Summary</v-btn>
              </v-toolbar>
              <v-text-field
                  v-model="search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  label="search"
                  class="mobile ml-5 mr-5 mb-3 mt-3"
              ></v-text-field>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="viewMonthlySummary(item)">
                mdi-eye
              </v-icon>

              <v-icon v-if="!isAuditorRole" small @click="deleteMonthlySummary(item)">
                mdi-delete
              </v-icon>

            </template>
            <template v-slot:no-data>
              <v-btn color="#2b3990" class="white--text" @click="getMonthlySummaries()">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <Foot class="hideOnPrint"/>

    <div id="printTable">
      <h2 class="text-center ma-3">Monthly Summary</h2>
      <v-row>
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="monthlySummaries"
              sort-by="StartDate"
              sort-desc
              :loading="isLoading"
              loading-text="Loading Monthly Summaries"
              :search="search"
              height="auto"
              hide-default-footer
              disable-pagination
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Monthly Summaries</v-toolbar-title>
              </v-toolbar>

            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '../../components/ClientNav'
import ClientSide from '../../components/ClientSide'
import Foot from '../../components/Footer'

const url = require("../../client_config/config").url;

export default {
  components: {
    ClientNav,
    ClientSide,
    Foot,
  },
  data: function() {
    return {
      headers: [
        {
          text: 'Start Date',
          align: 'start',
          value: 'StartDate',
        },
        { text: "Month", value: "Month" },
        { text: "Service Code", value: "Code" },
        { text: "Summary", value: "SummaryTitle", width: '50%' },
        { text: "Submitted", value: "Submitted" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      addMonthlySummaryHeaders: [
        {
          text: 'Report Date',
          align: 'start',
          value: 'ReportDate',
        },
        { text: "Summary", value: "Summary" },
        { text: "Manager Signature", value: "ManagerSignature" },
        { text: "Supervisor Signature", value: "SupervisorSignature" },
        // { text: "ClientServSig", value: "ClientServSig" },
        // { text: "Submitted", value: "Submitted" },
        // { text: "Providers", value: "Providers" },
        // { text: "Guardian", value: "Guardian" },
        // { text: "ClientID", value: "ClientID" },
      ],
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      msg: false,
      signedManager: false,
      signedSupervisor: false,
      signedClient: false,
      search: "",
      text:"",
      monthlySummaries: [],
      allWeeklySummaries: [],
      weeklyIdsSummaries:[],
      units: [],
      codes: [],
      tempData: [],
      users: [],
      goals: [],
      staff: "",
      unitID: localStorage.getItem('unitID'),
      clientID: this.$route.params.clientID,
      userID: localStorage.getItem('userID'),
      titleForm: "New Weekly Summary",
      summaryID: "",
      newStartDate: "",
      newEndDate: "",
      newCurrentDate: new Date(),
      newPlanDate: "",
      newCode: "",
      newGoal: "",
      newPurpose: "",
      newDetails: "",
      summaryTitle: "",
      newSummary: "",
      newManagerSignature: "",
      newSupervisorSignature: "",
      newClientServSig: "",
      newSubmitted: "",
      newProviders: "",
      newGuardian: "",
      goal: '',
      tempGoals: [],
      newMonth: "",
      isLoading: true,
    };
  },

  computed: {
    isAuditorRole() {
            return localStorage.getItem("userRole") === 'Auditor'
        }
  },

  watch: {},

  created() {
    this.getMonthlySummaries();
    this.getUsers();
    this.getServiceCodesFromCode();
    this.getListOfProviders();
    this.getStrategies()
  },

  methods: {

    initialize() {
      this.monthlySummaries = [];
    },

    viewMonthlySummary(item) {
        this.$router.push({
            path: `/monthlySummaries/${this.clientID}/update/${item._id}`,
            query: {updateSummary: true}
        })
    },

    showAdd() {
      this.$router.push({
          path: `/monthlySummaries/${this.clientID}/new`,
          query: {createMonthlySummary: true}
      })
    },

    deleteMonthlySummary(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this monthly summary?") &&
      this.monthlySummaryDelete(id);

    },

    monthlySummaryDelete(id) {
      axios.delete(`${url}/monthlySummary/${id}`)
          .then((response) => {
            this.getMonthlySummaries();
            if (response.status == 400) {
              response.json().then(function(data) {
                return data.msg;
              });
            }
            this.msg=true;
            this.text="The monthly summary has been deleted successfully.";
          });
    },

    getStrategies: function() {
      axios.get(`${url}/support/${this.clientID}`).then(res => {
        this.tempGoals = res.data.supports
        this.goals = []
        for(var i = 0; i < this.tempGoals.length; i++){
          if(this.tempGoals[i].Active == "Active"){
            this.goals.push(this.tempGoals[i])
          }
        }
      })
    },

    close() {
      this.clear()
      this.dialog = false;
      document.getElementById('printItem').style.display = "none";
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    updateMonthlySummary() {
      var req_body = {
        StartDate: this.newStartDate,
        EndDate: this.newEndDate,
        Month: this.newMonth,
        CurrentDate: this.newCurrentDate,
        PlanDate: this.newPlanDate,
        Code: this.newCode,
        Goal: this.goal.Goal,
        Purpose: this.newPurpose,
        Details: this.newDetails,
        SummaryTitle: this.summaryTitle,
        Summary: this.newSummary,
        ManagerSig: this.signedManager,
        MangerSignature: this.newManagerSignature,
        SupervisorSig: this.signedSupervisor,
        SupervisorSignature: this.newSupervisorSignature,
        ClientServSig: this.newClientServSig,
        ServSig: this.signedClient,
        Submitted: this.newSubmitted,
        Providers: this.newProviders,
        Guardian: this.newGuardian,
      };
      axios.put(`${url}/monthlySummary/${this.summaryID}`, req_body).then((response) => {
        this.getMonthlySummaries();
        if (response.status == 400) {
          response.json().then(function(data) {
            alert(data.msg);
          });
        }
        this.msg=true;
        this.text="The monthly summary has been updated successfully.";
      });
      this.close();
    },

    getMonthlySummaries: function() {
      this.isLoading = true;
      axios.get(`${url}/monthlySummary/client/${this.clientID}`).then(res => {
        this.monthlySummaries = res.data.summaries
        //     this.tempData = res.data.summaries;
        // for (var i=0; i < this.tempData.length; i++){
        //   if (this.tempData[i].ClientID == this.clientID) {
        //     this.monthlySummaries.push(this.tempData[i])
        //   }
        // }
      }).finally(() => this.isLoading = false);
    },

    getAllWeeklyReportWithinDateRange() {
      this.isLoading = true;
      axios.get(`${url}/weeklySummary/${this.newStartDate}/${this.newEndDate}/${this.clientID}`).then(res => {
        this.allWeeklySummaries = res.data.summaries
        for(let counterForWeeklySummaries=0; counterForWeeklySummaries < this.allWeeklySummaries.length; counterForWeeklySummaries++){
          this.weeklyIdsSummaries.push(this.allWeeklySummaries[counterForWeeklySummaries]._id)
        }
      }).finally(() => this.isLoading = false);
    },

    addMonthlySummary: function() {
      var req_body = {
        StartDate: this.newStartDate,
        EndDate: this.newEndDate,
        Month: this.newMonth,
        CurrentDate: this.newCurrentDate,
        PlanDate: this.newPlanDate,
        Code: this.newCode,
        Goal: this.goal.Goal,
        Purpose: this.newPurpose,
        Details: this.newDetails,
        SummaryTitle: this.summaryTitle,
        Summary: this.weeklyIdsSummaries,
        ManagerSignature: this.newManagerSignature,
        ManagerSig: this.signedManager,
        SupervisorSignature: this.newSupervisorSignature,
        SupervisorSig: this.signedSupervisor,
        ClientServSig: this.newClientServSig,
        ServSig: this.signedClient,
        Submitted: this.newSubmitted,
        Providers: this.newProviders,
        Guardian: this.newGuardian,
        ClientID: this.clientID,
      };

      axios.post(`${url}/monthlySummary`, req_body ).then(res => {
        this.getMonthlySummaries();
        if (res.status == 400) {
          res.json().then(function(data) {
            this.text=data.msg;
          });
        }
        this.msg=true;
        this.text="The new monthly summary has been added successfully.";
      });
      this.close();
    },

    getUsers: function() {
      axios.get(`${url}/users`).then(async res => {
        this.users = res.data.users;
        for (var i=0; i < this.users.length; i++){
          if (this.userID == this.users[i]._id) {
            this.staff = this.users[i].Name
          }
        }
      });
    },

    addManagerSig: function() {
      if(!this.signedManager) return this.newManagerSignature = ''
      this.newManagerSignature = this.staff + " - " + new Date();
    },

    addSupervisorSig: function() {
      if(!this.signedSupervisor) return this.newSupervisorSignature = ''
      this.newSupervisorSignature = this.staff + " - " + new Date();
    },

    addClientSig: function() {
      if(!this.signedClient) return this.newClientServSig = ''
      this.newClientServSig = this.staff + " - " + new Date();
    },

    getServiceCodesFromCode() {
      axios.get(`${url}/serviceCodes/client/${this.clientID}`).then(async res => {
        this.codes = res.data.serviceCodes;
      });
    },

    getListOfProviders() {
      axios.get(`${url}/codes/providerslist`).then(async res => {
        this.providers = res.data;
      });
    },

    updateGoal(goal){
      console.log(goal.Goal)
      this.newDetails = goal.Assist
      this.newPurpose = goal.Purpose
    },

    clear(){
      this.newStartDate = "";
      this.newEndDate = "";
      this.newMonth = "";
      this.newCurrentDate = "";
      this.newPlanDate = "";
      this.newCode = "";
      this.newGoal = "";
      this.newPurpose = "";
      this.newDetails = "";
      this.newSummary = "";
      this.summaryTitle = "";
      this.newManagerSignature = "";
      this.newSupervisorSignature = "";
      this.newClientServSig = "";
      this.newSubmitted = "";
      this.newProviders = "";
      this.newGuardian = "";
      this.allWeeklySummaries = [];
      this.signedManager = false;
      this.signedSupervisor = false;
      this.signedClient = false;
    },

    printTable() {
        document.getElementById('printItem').style.display = "none";
        document.getElementById('printTable').style.display = "block";


        window.print()

    },

    printItem() {
        document.getElementById('printTable').style.display = "none";
        document.getElementById('printItem').style.display = "block";


        window.print()
    },

  },

};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }

  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }

  }

  #printTable{
    display: none;
  }

  #printItem{
    display: none;
  }

  @media only screen and (min-width: 768px) {
      .mobile {
        display: none;
      }
    }

    @media only screen and (max-width: 600px) {
      .desktop {
        display: none;
      }

    }

    @media print {
      #printTable{
      display: block;
      border: none;
      width: 1200px;
      padding-right: 300px;
      margin-left: -200px;

      }
      #printItem{
      display: block;
      border: none;
      width: 1200px;
      padding-right: 300px;
      margin-left: -200px;


      }
      .hideOnPrint {
        display: none;
        border: none;
      }

      nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
        display: none;
        border: none;

      }

      @page { margin: 0; }
      body { margin: 1.6cm; }


    }
</style>
